
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refund-policy",
      function () {
        return require("private-next-pages/refund-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refund-policy"])
      });
    }
  